<template>
  <div class="paymentOverview">
    <!-- We only show Patient related billing details. If Patient-Paid, show all details. If Provider-Paid, show simplified billing info -->
    <div class="overviewHeader">
      <div>Payment Overview</div>
      <!-- if has billingInfo or payFixedAmount: show current_patient_balance even 0.00-->
      <div>Total: {{ formatPrice(current_patient_balance) }}</div>
    </div>
    <div class="headerDivider" v-if="!payFixedAmount" />

    <!-- If NOT is_family_order: directly show all billing details of the current order -->
    <div class = "overviewContentsWrapper" v-if = "!is_family_order && !payFixedAmount">
      <billing-row label="Subtotal" :value="billingInfo?.patient_bill?.subtotal" :format-price="formatPrice" :condition="!isProviderPaid" />
      <billing-row label="Patient's Subtotal" :value="billingInfo?.patient_bill?.subtotal" :format-price="formatPrice" :condition="isProviderPaid" />
      <billing-row label="Tax" :value="billingInfo?.tax" :format-price="formatPrice" :condition="!isProviderPaid" />
      <billing-row label="Lab Processing Fee" :value="billingInfo?.va_processing_fee" :format-price="formatPrice" :condition="!isProviderPaid" />
      <billing-row label="GZ NY Processing Fee" :value="billingInfo?.ny_processing_fee" :format-price="formatPrice" :condition="!isProviderPaid" tooltip="Covers the specialized laboratory requirements Vibrant meets to offer a New York State-compliant Gut Zoomer." />
      <billing-row label="Drop Ship Fee" :value="billingInfo?.drop_ship_fee" :format-price="formatPrice" :condition="!isProviderPaid" />
      <billing-row label="International Shipping Fee" :value="billingInfo?.international_shipping_fee" :format-price="formatPrice" :condition="!isProviderPaid" />
      <billing-row label="Discount" :value="billingInfo?.discount" :format-price="formatPrice" :condition="!isProviderPaid" />

      <div
        class="dashedDivider"
v-if="billingInfo?.consultation_fee && Number(billingInfo.consultation_fee)!=0 && !isProviderPaid"
      ></div>
      <billing-row :label="consultation_fee_display_name" :value="billingInfo?.consultation_fee" :format-price="formatPrice" :condition="!isProviderPaid" />

      <div
        class="dashedDivider"
        v-if="patient_applied_payments_total != 0"
      ></div>
      <billing-row :label="isProviderPaid ? 'Patient\'s Applied Payment' : 'Applied Payment'" :value="patient_applied_payments_total > 0 ? -patient_applied_payments_total : patient_applied_payments_total" :format-price="formatPrice" />
    </div>
    <!-- If is_family_order: show multiple order's billing details with expandable div -->
    <!--  -->
    <div class = "overviewContentsWrapper" v-else-if = "is_family_order && !payFixedAmount">
      <!-- familyOrdersBillingDetails SHOULD NOT be null or undefined under this case -->
      <div class = "mutipleContentDetails" v-for = "unit_billing_info in familyOrdersBillingDetails" :key = "`${unit_billing_info.accession_id}-billing-info`">
        <div class = "unitBillingHeaderWrapper">
          <!-- billingDetailsExpandableDivManagementMap SHOULD NOT be null or undefined since it is based on familyOrdersBillingDetails -->
          <div class = "unitBillingHeader" @click = "billingDetailsExpandableDivManagementMap[unit_billing_info.accession_id] = !billingDetailsExpandableDivManagementMap?.[unit_billing_info.accession_id]">
            <div class="font-medium">
              {{ `#${unit_billing_info.accession_id}` }}
            </div>
            <img src = "@/assets/payment/white_arrow_down_icon.svg" 
            :class = "[
              'billing-info-dropdown-arrow', 
              'rotate-0',
              {'rotate-180': billingDetailsExpandableDivManagementMap?.[unit_billing_info.accession_id]}
            ]"/>
          </div>
          <div class="font-normal">
            {{ formatPrice(unit_billing_info_patient_balance(unit_billing_info))}}
          </div>
        </div>
        <div class = "unitBillingDetails" v-if = "billingDetailsExpandableDivManagementMap?.[unit_billing_info.accession_id]">
          <billing-row label="Subtotal" :value="unit_billing_info?.subtotal" :format-price="formatPrice" :condition="!isProviderPaid" />
          <billing-row label="Patient's Subtotal" :value="unit_billing_info?.patient_bill?.subtotal" :format-price="formatPrice" :condition="isProviderPaid" />
          <billing-row label="Tax" :value="unit_billing_info?.tax" :format-price="formatPrice" :condition="!isProviderPaid" />
          <billing-row label="Lab Processing Fee" :value="unit_billing_info?.va_processing_fee" :format-price="formatPrice" :condition="!isProviderPaid" />
          <billing-row label="GZ NY Processing Fee" :value="unit_billing_info?.ny_processing_fee" :format-price="formatPrice" :condition="!isProviderPaid" tooltip="Covers the specialized laboratory requirements Vibrant meets to offer a New York State-compliant Gut Zoomer." />
          <billing-row label="Drop Ship Fee" :value="unit_billing_info?.drop_ship_fee" :format-price="formatPrice" :condition="!isProviderPaid" />
          <billing-row label="International Shipping Fee" :value="unit_billing_info?.international_shipping_fee" :format-price="formatPrice" :condition="!isProviderPaid" />
          <billing-row label="Discount" :value="unit_billing_info?.discount" :format-price="formatPrice" :condition="!isProviderPaid" />

          <div
            class="dashedDivider"
            v-if="Number(unit_billing_info.consultation_fee)!=0 && !isProviderPaid"
          ></div>
          <billing-row :label="consultation_fee_display_name" :value="unit_billing_info?.consultation_fee" :format-price="formatPrice" :condition="!isProviderPaid" />

          <div
            class="dashedDivider"
            v-if="unit_order_patient_applied_payments_total_under_family_orders(unit_billing_info) != 0"
          ></div>
          <billing-row :label="isProviderPaid ? 'Patient\'s Applied Payment' : 'Applied Payment'" :value="unit_order_patient_applied_payments_total_under_family_orders(unit_billing_info) > 0 ? -unit_order_patient_applied_payments_total_under_family_orders(unit_billing_info) : unit_order_patient_applied_payments_total_under_family_orders(unit_billing_info)" :format-price="formatPrice" />
        </div>
      </div>
    </div>
    <!-- <div class="contentDivider" />
    <div class="promoContainer">
      <el-input v-model="promoCode" placeholder="Promo Code" class="promoInput">
        <template v-slot:prefix>
          <img src="@/assets/payment/promo.svg" alt="promo" />
        </template>
      </el-input>
      <el-button
        v-loading="loadingPromo"
        class="promoButton"
        @click="submitPromo"
        >Apply</el-button
      >
    </div> -->
  </div>
</template>

<script>
import { usePaymentStore } from "@/stores/PaymentStore.ts";
import { mapState, mapActions } from "pinia";
import BillingRow from './BillingRow.vue';
export default {
  components: {
    BillingRow,
  },
  name: "PaymentOverview",
  props: {
    payFixedAmount: Boolean,
  },
  mounted() {
    // Initialize the billingDetailsExpandableDivManagementMap when the component is mounted
    this.billingDetailsExpandableDivManagementMap = this.initiateBillingDetailsExpandableDivManagementMap(this.familyOrdersBillingDetails);
  },
  data() {
    return {
      promoCode: "",
      billingDetailsExpandableDivManagementMap: null,
    };
  },
  computed: {
    ...mapState(()=>usePaymentStore(), [
      'amount_to_pay',
      "billingInfo", 
      "loadingPromo",
      'has_billing_issue',
      "consultation_fee_name",
      'charge_method',
      'is_family_order',
    ]),
    familyOrdersBillingDetails() {
      return this.billingInfo?.family_orders?.family_order_details;
    },
    isProviderPaid(){
      return this.charge_method == 'customerPay' || this.charge_method == 'netPay';
    },
    formatPrice() {
      return (price) => {
        return Number(price).toLocaleString("en-US", {
          style: "currency",
          currency: (this.billingInfo?.currency || 'USD').toUpperCase(),
          minimumFractionDigits: 2,
        }).replace('CHF','₣');
      };
    },
    current_patient_balance(){
      const output = this.amount_to_pay
      ? parseFloat(
          (Number(this.amount_to_pay) / 100).toFixed(2)
        )
      : (this.is_family_order ? Number(this.billingInfo?.family_orders?.patient_total ?? 0) : Number(this.billingInfo?.patient_bill?.total ?? 0));
      console.log('current_patient_balance', output);
      return output;
    },
    unit_billing_info_patient_balance(){
      return (unit_billing_info)=> Number(unit_billing_info?.patient_bill?.total ?? 0);
    },
    unit_order_patient_applied_payments_total_under_family_orders() {
      return (unit_billing_info) => unit_billing_info?.patient_bill?.applied_payments
      ? unit_billing_info.patient_bill.applied_payments.reduce(
          (sum, payment) => sum + Number(payment.amount),
          0
        )
      : 0;
    },
    patient_applied_payments_total() {
      return this.billingInfo?.patient_bill?.applied_payments
      ? this.billingInfo.patient_bill.applied_payments.reduce(
          (sum, payment) => sum + Number(payment.amount),
          0
        )
      : 0;
    },
    consultation_fee_display_name(){
      return this.consultation_fee_name ? this.consultation_fee_name : "Consultation Fee";
    },
  },
  watch:{
    familyOrdersBillingDetails:{
      handler(newVal) {
        // Regenerate the billingDetailsExpandableDivManagementMap when familyOrdersBillingDetails changes
        this.billingDetailsExpandableDivManagementMap = this.initiateBillingDetailsExpandableDivManagementMap(newVal);
      },
      deep: true,
    }
  },
  methods: {
    ...mapActions(()=>usePaymentStore(), ["applyPromo"]),
    async submitPromo() {
      if (this.promoCode)
        try {
          await this.applyPromo(this.promoCode);
        } catch (error) {
          console.error(error);
        }
      this.promoCode = "";
    },
    initiateBillingDetailsExpandableDivManagementMap(familyOrdersBillingDetails){
      if(familyOrdersBillingDetails){
        var output = {};
        familyOrdersBillingDetails.forEach(unitBillingInfo => {
          output[unitBillingInfo.accession_id] = false;
        });
        return output;
      }
      return null;
    }
  },

};
</script>

<style scoped>
.paymentOverview {
  width: 56vw;
  /* min-width: 600px; */
  height: fit-content;
  border-radius: 10px;
  background-color: #0e4672;
  padding: 24px 38px;
}
.paymentOverview > div {
  margin-bottom: 12px;
}

.overviewContentsWrapper {
  width: 100%;
  /* min-width: 600px; */
  height: fit-content;
}
.overviewContentsWrapper > div {
  margin-bottom: 12px;
}

.overviewHeader {
  display: flex;
  justify-content: space-between;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.51px;
  text-align: left;
  color: #ffffff;
}

.headerDivider {
  border: 0.5px solid #e6e6e6;
}

.contentDivider {
  border: 0.5px solid #ffffff;
}

.dashedDivider {
  border: 0.5px dashed #ffffff;
}

.overviewContent {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.4px;
  text-align: left;
  color: #ffffff;
}
.mutipleContentDetails{
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.4px;
  text-align: left;
  color: #ffffff;
}
.unitBillingHeaderWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.unitBillingHeader{
  display:flex;
  column-gap: 8px;
  align-items: center;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.4px;
  cursor: pointer;
}
.billing-info-dropdown-arrow {
  width: 20px;
  height: 20px;
}
.rotate-0{
    transform: rotate(0deg);
    transition: all 0.5s;
}
.rotate-180{
    transform:rotate(-180deg);
}
.unitBillingDetails{
  width: 100%;
  /* min-width: 600px; */
  height: fit-content;
  padding-left:20px;
}
.unitBillingDetails > div {
  margin-bottom: 12px;
}

.promoContainer {
  display: flex;
  justify-content: space-between;
  height: 36px;
  margin-bottom: 0px !important;
}

.promoButton {
  width: 123px;
  height: 36px;
  border-radius: 4px;
  margin-left: 16px;
  border: 1px solid #20a8c3;
  background: #20a8c3;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  text-align: left;
  color: #ffffff;
}

.promoButton:hover {
  background: #30c0db;
  border: 1px solid #30c0db;
}

@media only screen and (max-width: 767px) {
  .paymentOverview {
    width: 90%;
    height: fit-content;
    border-radius: 10px;
    background-color: #0e4672;
    padding: 18px;
    margin-left: 27px !important;
    margin-right: 27px !important;
  }
  .paymentOverview > div {
    margin-bottom: 8px;
  }

  .promoContainer {
    height: 30px;
  }

  .promoContainer > * {
    font-size: 12px;
  }

  .promoButton {
    height: 30px;
    width: 114px;
  }

  .overviewContent {
    font-size: 12px;
    line-height: 14px;
  }
  .mutipleContentDetails{
    row-gap: 8px;
    font-size: 12px;
    line-height: 14px;
  }

  .unitBillingHeader{
    font-size: 12px;
    line-height: 14px;
  }
  .billing-info-dropdown-arrow {
    width: 20px;
    height: 20px;
    padding:4px;
    box-sizing: content-box;
  }
  .unitBillingDetails > div {
    margin-bottom: 8px;
  }
  .overviewHeader {
    font-size: 16px;
    font-weight: 700;
    line-height: 18.75px;
  }
}
</style>
